<a class="btn btn-warning btn-block" routerLink="/topic-list">Topic List</a>
<router-outlet></router-outlet>